import { render, staticRenderFns } from "./TheOrganizationStaffRoleForm.vue?vue&type=template&id=f6a47dea&"
import script from "./TheOrganizationStaffRoleForm.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationStaffRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports